.section {
  max-width: var(--container);
  margin: 0 auto;
  padding: 44px var(--gutter) 0;
  box-sizing: border-box;
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px 24px;
  margin-bottom: 18px;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 38px;
  line-height: 1;
  letter-spacing: -0.01em;
}

.eyebrow {
  margin: 10px 0 0;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: var(--eyebrow);
}

.more {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  font-size: 14px;
  font-weight: 500;
}

.mobileOnly {
  margin-top: 4px;
  gap: 10px;
}

.desktopOnly {
  display: none;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

@media (min-width: 1024px) {
  .section {
    padding-top: 72px;
  }

  .head {
    margin-bottom: 26px;
  }

  .title {
    font-size: 54px;
  }

  .eyebrow {
    margin-top: 12px;
    font-size: 12px;
    letter-spacing: 0.32em;
  }

  /* Four cards across the full 1240 px container (4 × 295 px); three below ~1180 px. */
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }

  .mobileOnly {
    display: none;
  }

  .desktopOnly {
    display: flex;
  }
}
